import React from 'react';
import { Button } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';

export default function ExcelExportButton({ onDownload, disabled, ...rest }) {
  return (
    <Button
      icon={<FileExcelOutlined />}
      onClick={onDownload}
      disabled={disabled}
      {...rest}
    />
  );
}
